import { render } from "./ListUsers.vue?vue&type=template&id=fba679b4&scoped=true"
import script from "./ListUsers.vue?vue&type=script&lang=js"
export * from "./ListUsers.vue?vue&type=script&lang=js"

import "./ListUsers.vue?vue&type=style&index=0&id=fba679b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba679b4"]])

export default __exports__